/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../../Library';
import { JsonCompat } from '../../../compat/JsonCompat';
import { NodeCompat } from '../../../compat/NodeCompat';
import { Constants } from '../../../core/Constants';
import { Document } from '../../../core/models/Document';
import { DocumentType } from '../../../core/models/DocumentType';
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { Extension } from '../../../core/models/Extension';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { Node } from '../../../core/models/Node';
import { NodePath } from '../../../core/models/NodePath';
import { ValidationProblem } from '../../../core/models/ValidationProblem';
import { Contact } from '../../../core/models/common/Contact';
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IExample } from '../../../core/models/common/IExample';
import { IExternalDocumentationParent } from '../../../core/models/common/IExternalDocumentationParent';
import { IPropertySchema } from '../../../core/models/common/IPropertySchema';
import { ISecurityRequirementParent } from '../../../core/models/common/ISecurityRequirementParent';
import { Info } from '../../../core/models/common/Info';
import { License } from '../../../core/models/common/License';
import { Operation } from '../../../core/models/common/Operation';
import { Parameter } from '../../../core/models/common/Parameter';
import { Schema } from '../../../core/models/common/Schema';
import { SecurityRequirement } from '../../../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { Tag } from '../../../core/models/common/Tag';
import { ReferenceUtil } from '../../../core/util/ReferenceUtil';
import { ConsumesProducesFinder } from '../../../core/visitors/ConsumesProducesFinder';
import { OperationFinder } from '../../../core/visitors/OperationFinder';
import { TraverserDirection } from '../../../core/visitors/TraverserDirection';
import { IOasParameterParent } from '../../models/IOasParameterParent';
import { OasHeader } from '../../models/OasHeader';
import { OasPathItem } from '../../models/OasPathItem';
import { OasPaths } from '../../models/OasPaths';
import { OasResponse } from '../../models/OasResponse';
import { OasResponses } from '../../models/OasResponses';
import { OasSchema } from '../../models/OasSchema';
import { OasXML } from '../../models/OasXML';
import { Oas20Definitions } from '../../v2/models/Oas20Definitions';
import { Oas20Document } from '../../v2/models/Oas20Document';
import { Oas20Headers } from '../../v2/models/Oas20Headers';
import { Oas20Items } from '../../v2/models/Oas20Items';
import { Oas20Operation } from '../../v2/models/Oas20Operation';
import { Oas20Parameter } from '../../v2/models/Oas20Parameter';
import { Oas20ParameterDefinition } from '../../v2/models/Oas20ParameterDefinition';
import { Oas20ParameterDefinitions } from '../../v2/models/Oas20ParameterDefinitions';
import { Oas20Response } from '../../v2/models/Oas20Response';
import { Oas20ResponseDefinitions } from '../../v2/models/Oas20ResponseDefinitions';
import { Oas20Schema } from '../../v2/models/Oas20Schema';
import { Oas20SchemaDefinition } from '../../v2/models/Oas20SchemaDefinition';
import { Oas20Scopes } from '../../v2/models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../../v2/models/Oas20SecurityDefinitions';
import { Oas20SecurityRequirement } from '../../v2/models/Oas20SecurityRequirement';
import { Oas20SecurityScheme } from '../../v2/models/Oas20SecurityScheme';
import { IOas20Visitor } from '../../v2/visitors/IOas20Visitor';
import { Oas30Components } from '../../v3/models/Oas30Components';
import { Oas30Contact } from '../../v3/models/Oas30Contact';
import { Oas30Document } from '../../v3/models/Oas30Document';
import { Oas30ExternalDocumentation } from '../../v3/models/Oas30ExternalDocumentation';
import { Oas30Header } from '../../v3/models/Oas30Header';
import { Oas30Info } from '../../v3/models/Oas30Info';
import { Oas30License } from '../../v3/models/Oas30License';
import { Oas30MediaType } from '../../v3/models/Oas30MediaType';
import { Oas30Operation } from '../../v3/models/Oas30Operation';
import { Oas30Parameter } from '../../v3/models/Oas30Parameter';
import { Oas30ParameterDefinition } from '../../v3/models/Oas30ParameterDefinition';
import { Oas30PathItem } from '../../v3/models/Oas30PathItem';
import { Oas30Paths } from '../../v3/models/Oas30Paths';
import { Oas30RequestBody } from '../../v3/models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../../v3/models/Oas30RequestBodyDefinition';
import { Oas30Response } from '../../v3/models/Oas30Response';
import { Oas30ResponseDefinition } from '../../v3/models/Oas30ResponseDefinition';
import { Oas30Responses } from '../../v3/models/Oas30Responses';
import { Oas30Schema } from '../../v3/models/Oas30Schema';
import { Oas30SchemaDefinition } from '../../v3/models/Oas30SchemaDefinition';
import { Oas30SecurityRequirement } from '../../v3/models/Oas30SecurityRequirement';
import { Oas30SecurityScheme } from '../../v3/models/Oas30SecurityScheme';
import { Oas30Server } from '../../v3/models/Oas30Server';
import { Oas30ServerVariable } from '../../v3/models/Oas30ServerVariable';
import { Oas30XML } from '../../v3/models/Oas30XML';
import { Server } from '../../../core/models/common/Server';
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { OasOperation } from '../../models/OasOperation';
import { OasParameter } from '../../models/OasParameter';
import { Oas20Example } from '../../v2/models/Oas20Example';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { Oas30Discriminator } from '../../v3/models/Oas30Discriminator';

/**
 * A visitor used to transform an OpenAPI 2.0 document into an OpenAPI 3.0.x document.
 * @author eric.wittmann@gmail.com
 * @class
 */
export class Oas20to30TransformationVisitor implements IOas20Visitor {
    /*private*/ doc30 : Oas30Document;

    /*private*/ _nodeMap : any = <any>({});

    /*private*/ _postProcessResponses : Array<Oas30Response> = <any>([]);

    /*private*/ _postProcessingComplete : boolean = false;

    /**
     * Retrieves the final result.
     * @return {Oas30Document}
     */
    public getResult() : Oas30Document {
        if(!this._postProcessingComplete) {
            this.postProcess();
        }
        return this.doc30;
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        this.doc30 = <Oas30Document>Library.createDocument(DocumentType.openapi3);
        let doc20 : Oas20Document = <Oas20Document>node;
        if(!NodeCompat.isNullOrUndefined(doc20.host)) {
            let basePath : string = doc20.basePath;
            if(NodeCompat.isNullOrUndefined(basePath)) {
                basePath = "";
            }
            let schemes : Array<string> = doc20.schemes;
            if(NodeCompat.isNullOrUndefined(schemes) || /* size */(<number>schemes.length) === 0) {
                schemes = NodeCompat.asList("http");
            }
            let server30 : Oas30Server = <Oas30Server>this.doc30.createServer();
            this.doc30.servers = <any>([]);
            /* add */(this.doc30.servers.push(server30)>0);
            if(/* size */(<number>schemes.length) === 1) {
                server30.url = /* get */schemes[0] + "://" + doc20.host + basePath;
            } else {
                server30.url = "{scheme}://" + doc20.host + basePath;
                let var30 : Oas30ServerVariable = <Oas30ServerVariable>server30.createServerVariable("scheme");
                server30.addServerVariable("scheme", var30);
                var30.default_ = /* get */schemes[0];
                var30.enum_ = NodeCompat.copyList(schemes);
                var30.description = "The supported protocol schemes.";
            }
        }
        this.mapNode(doc20, this.doc30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.doc30.info = this.doc30.createInfo();
        this.doc30.info.title = node.title;
        this.doc30.info.description = node.description;
        this.doc30.info.termsOfService = node.termsOfService;
        this.doc30.info.version = node.version;
        this.mapNode(node, this.doc30.info);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        let info30 : Oas30Info = <Oas30Info>this.lookup(node.parent());
        let contact30 : Oas30Contact = <Oas30Contact>info30.createContact();
        info30.contact = contact30;
        contact30.name = node.name;
        contact30.url = node.url;
        contact30.email = node.email;
        this.mapNode(node, contact30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        let info30 : Oas30Info = <Oas30Info>this.lookup(node.parent());
        let license30 : Oas30License = <Oas30License>info30.createLicense();
        info30.license = license30;
        license30.name = node.name;
        license30.url = node.url;
        this.mapNode(node, license30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        this.doc30.paths = this.doc30.createPaths();
        this.mapNode(node, this.doc30.paths);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        let paths30 : Oas30Paths = <Oas30Paths>this.lookup(node.parent());
        let pathItem30 : Oas30PathItem = <Oas30PathItem>paths30.createPathItem(node.getPath());
        paths30.addPathItem(node.getPath(), pathItem30);
        pathItem30.$ref = this.updateRef(node.$ref);
        this.mapNode(node, pathItem30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        let op : Oas20Operation = <Oas20Operation>node;
        let pathItem30 : Oas30PathItem = <Oas30PathItem>this.lookup(node.parent());
        let operation30 : Oas30Operation = <Oas30Operation>pathItem30.createOperation(node.getType());
        pathItem30.setOperation(operation30);
        operation30.tags = op.tags;
        operation30.summary = op.summary;
        operation30.description = op.description;
        operation30.operationId = op.operationId;
        operation30.deprecated = op.deprecated;
        if(!NodeCompat.isNullOrUndefined(op.schemes) && /* size */(<number>op.schemes.length) > 0 && !NodeCompat.isNullOrUndefined(this.doc30.servers) && /* size */(<number>this.doc30.servers.length) > 0) {
            let server30 : Oas30Server = <Oas30Server>operation30.createServer();
            operation30.servers = <any>([]);
            /* add */(operation30.servers.push(server30)>0);
            server30.url = /* get */this.doc30.servers[0].url;
            if(/* size */(<number>op.schemes.length) === 1) {
                server30.url = /* replace */server30.url.split("{scheme}").join(/* get */op.schemes[0]);
                server30.removeServerVariable("scheme");
            } else {
                server30.url = "{scheme}" + server30.url.substring(server30.url.indexOf("://"));
                let var30 : Oas30ServerVariable = <Oas30ServerVariable>server30.createServerVariable("scheme");
                server30.addServerVariable("scheme", var30);
                var30.description = "The supported protocol schemes.";
                var30.default_ = /* get */op.schemes[0];
                var30.enum_ = NodeCompat.copyList(op.schemes);
            }
        }
        this.mapNode(op, operation30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        let param20 : Oas20Parameter = <Oas20Parameter>node;
        if(NodeCompat.equals(param20.in, "body")) {
            let operation30 : Oas30Operation = <Oas30Operation>this.lookup(this.findParentOperation(param20));
            if(!NodeCompat.isNullOrUndefined(operation30)) {
                let body30 : Oas30RequestBody = <Oas30RequestBody>operation30.createRequestBody();
                operation30.requestBody = body30;
                body30.description = param20.description;
                body30.required = param20.required;
                if(!NodeCompat.isNullOrUndefined(param20.schema)) {
                    let consumes : Array<string> = this.findConsumes(param20);
                    let schema : Oas20Schema = <Oas20Schema>param20.schema;
                    consumes.forEach(((schema,body30) => {
                        return (ct) => {
                            let mediaType30 : Oas30MediaType = body30.createMediaType(ct);
                            body30.addMediaType(ct, mediaType30);
                            let schema30 : Oas30Schema = mediaType30.createSchema();
                            mediaType30.schema = this.toSchema(schema, schema30, true);
                            this.mapNode(schema, schema30);
                        }
                    })(schema,body30));
                }
            }
        } else if(NodeCompat.equals(param20.in, "formData")) {
            let operation30 : Oas30Operation = <Oas30Operation>this.lookup(this.findParentOperation(param20));
            if(!NodeCompat.isNullOrUndefined(operation30)) {
                let consumes : Array<string> = this.findConsumes(param20);
                if(!this.hasFormDataMimeType(consumes)) {
                    consumes = NodeCompat.asList("application/x-www-form-urlencoded");
                }
                consumes.forEach(((operation30,param20) => {
                    return (ct) => {
                        if(this.isFormDataMimeType(ct)) {
                            let body30 : Oas30RequestBody = operation30.requestBody;
                            if(NodeCompat.isNullOrUndefined(body30)) {
                                body30 = operation30.createRequestBody();
                                operation30.requestBody = body30;
                                body30.required = true;
                            }
                            let mediaType30 : Oas30MediaType = body30.getMediaType(ct);
                            if(NodeCompat.isNullOrUndefined(mediaType30)) {
                                mediaType30 = body30.createMediaType(ct);
                                body30.addMediaType(ct, mediaType30);
                            }
                            let schema30 : Oas30Schema = mediaType30.schema;
                            if(NodeCompat.isNullOrUndefined(schema30)) {
                                schema30 = mediaType30.createSchema();
                                mediaType30.schema = schema30;
                                schema30.type = "object";
                            }
                            let property30 : Oas30Schema.Oas30PropertySchema = <Oas30Schema.Oas30PropertySchema>schema30.createPropertySchema(param20.name);
                            schema30.addProperty(param20.name, property30);
                            property30.description = param20.description;
                            this.toSchema(param20, property30, false);
                            this.mapNode(param20, schema30);
                        }
                    }
                })(operation30,param20));
            }
        } else {
            if(this.isRef(param20)) {
                let paramDef : Oas20ParameterDefinition = <Oas20ParameterDefinition>ReferenceUtil.resolveRef$java_lang_String$io_apicurio_datamodels_core_models_Node(param20.$ref, param20);
                if(!NodeCompat.isNullOrUndefined(paramDef) && NodeCompat.equals(paramDef.in, "body")) {
                    let parent30 : Oas30Operation = <Oas30Operation>this.lookup(this.findParentOperation(param20));
                    if(!NodeCompat.isNullOrUndefined(parent30)) {
                        let body30 : Oas30RequestBody = parent30.createRequestBody();
                        parent30.requestBody = body30;
                        body30.$ref = "#/components/requestBodies/" + paramDef.getName();
                        this.mapNode(param20, body30);
                        return;
                    }
                }
                if(!NodeCompat.isNullOrUndefined(paramDef) && NodeCompat.equals(paramDef.in, "formData")) {
                    Library.readNode(Library.writeNode(paramDef), param20);
                    param20.$ref = null;
                    this.visitParameter(param20);
                    return;
                }
            }
            let parent30 : IOasParameterParent = <IOasParameterParent><any>this.lookup(param20.parent());
            let param30 : Oas30Parameter = <Oas30Parameter>parent30.createParameter();
            parent30.addParameter(param30);
            this.transformParam(param20, param30);
            this.mapNode(param20, param30);
        }
    }

    /*private*/ transformParam(node : Oas20Parameter, param30 : Oas30Parameter) : Oas30Parameter {
        param30.$ref = this.updateRef(node.$ref);
        if(!NodeCompat.isNullOrUndefined(param30.$ref)) {
            return param30;
        }
        param30.name = node.name;
        param30.in = node.in;
        param30.description = node.description;
        param30.required = node.required;
        param30.allowEmptyValue = node.allowEmptyValue;
        param30.schema = this.toSchema(node, <Oas30Schema>param30.createSchema(), false);
        this.collectionFormatToStyleAndExplode(node, param30);
        return param30;
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        let pd20 : Oas20ParameterDefinition = <Oas20ParameterDefinition><any>node;
        if(NodeCompat.equals(pd20.in, "body")) {
            let parent30 : Oas30Components = this.getOrCreateComponents();
            let bodyDef30 : Oas30RequestBodyDefinition = parent30.createRequestBodyDefinition(pd20.getName());
            parent30.addRequestBodyDefinition(pd20.getName(), bodyDef30);
            bodyDef30.description = pd20.description;
            bodyDef30.required = pd20.required;
            if(!NodeCompat.isNullOrUndefined(pd20.schema)) {
                let consumes : Array<string> = this.findConsumes(pd20);
                let schema : Oas20Schema = <Oas20Schema>pd20.schema;
                consumes.forEach(((schema,bodyDef30) => {
                    return (ct) => {
                        let mediaType30 : Oas30MediaType = bodyDef30.createMediaType(ct);
                        bodyDef30.addMediaType(ct, mediaType30);
                        let schema30 : Oas30Schema = mediaType30.createSchema();
                        mediaType30.schema = this.toSchema(schema, schema30, true);
                        this.mapNode(schema, schema30);
                    }
                })(schema,bodyDef30));
            }
        } else if(NodeCompat.equals(pd20.in, "formData")) {
        } else {
            let components30 : Oas30Components = this.getOrCreateComponents();
            let paramDef30 : Oas30ParameterDefinition = components30.createParameterDefinition(pd20.getName());
            components30.addParameterDefinition(pd20.getName(), paramDef30);
            this.transformParam(pd20, paramDef30);
            this.mapNode(pd20, paramDef30);
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        let parent30 : IExternalDocumentationParent = <IExternalDocumentationParent><any>this.lookup(node.parent());
        let externalDocs30 : Oas30ExternalDocumentation = <Oas30ExternalDocumentation>parent30.createExternalDocumentation();
        parent30.setExternalDocumentation(externalDocs30);
        externalDocs30.description = node.description;
        externalDocs30.url = node.url;
        this.mapNode(node, externalDocs30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        let req : Oas20SecurityRequirement = <Oas20SecurityRequirement>node;
        let parent30 : ISecurityRequirementParent = <ISecurityRequirementParent><any>this.lookup(req.parent());
        let securityRequirement30 : Oas30SecurityRequirement = <Oas30SecurityRequirement>parent30.createSecurityRequirement();
        parent30.addSecurityRequirement(securityRequirement30);
        req.getSecurityRequirementNames().forEach(((securityRequirement30,req) => {
            return (name) => {
                securityRequirement30.addSecurityRequirementItem(name, req.getScopes(name));
            }
        })(securityRequirement30,req));
        this.mapNode(req, securityRequirement30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        let parent30 : Oas30Operation = <Oas30Operation>this.lookup(node.parent());
        let responses30 : Oas30Responses = <Oas30Responses>parent30.createResponses();
        parent30.responses = responses30;
        this.mapNode(node, responses30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        let parent30 : Oas30Responses = <Oas30Responses>this.lookup(node.parent());
        let response30 : Oas30Response = <Oas30Response>parent30.createResponse(node.getStatusCode());
        parent30.addResponse(node.getStatusCode(), response30);
        response30.$ref = this.updateRef(node.$ref);
        this.transformResponse(<Oas20Response>node, response30);
        this.mapNode(node, response30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        let parent30 : Oas30Components = this.getOrCreateComponents();
        let responseDef30 : Oas30ResponseDefinition = parent30.createResponseDefinition(node.getName());
        parent30.addResponseDefinition(node.getName(), responseDef30);
        this.transformResponse(<Oas20Response><any>node, responseDef30);
        this.mapNode(<Oas20Response><any>node, responseDef30);
    }

    /*private*/ transformResponse(node : Oas20Response, response30 : Oas30Response) {
        response30.description = node.description;
        if(!NodeCompat.isNullOrUndefined(node.schema)) {
            let produces : Array<string> = this.findProduces(node);
            let schema : Oas20Schema = node.schema;
            produces.forEach(((schema) => {
                return (ct) => {
                    let mediaType30 : Oas30MediaType = response30.createMediaType(ct);
                    response30.addMediaType(ct, mediaType30);
                    let schema30 : Oas30Schema = mediaType30.createSchema();
                    mediaType30.schema = this.toSchema(schema, schema30, true);
                    if(!NodeCompat.isNullOrUndefined(node.examples)) {
                        let ctexample : any = node.examples.getExample(ct);
                        if(!NodeCompat.isNullOrUndefined(ctexample)) {
                            mediaType30.example = ctexample;
                        }
                    }
                    this.mapNode(schema, schema30);
                }
            })(schema));
            if(/* size */(<number>produces.length) > 1) {
                /* add */(this._postProcessResponses.push(response30)>0);
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        let parent30 : Oas30Response = <Oas30Response>this.lookup(node.parent());
        this.mapNode(node, parent30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        let parent30 : Oas30Response = <Oas30Response>this.lookup(node.parent());
        let header30 : Oas30Header = parent30.createHeader(node.getName());
        parent30.addHeader(node.getName(), header30);
        header30.description = node.description;
        header30.schema = this.toSchema(node, header30.createSchema(), false);
        this.mapNode(node, header30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        let parent30 : Oas30Schema = this.findItemsParent(node);
        let items30 : Oas30Schema.Oas30ItemsSchema = <Oas30Schema.Oas30ItemsSchema>parent30.createItemsSchema();
        parent30.items = items30;
        this.toSchema(node, items30, false);
        this.mapNode(node, items30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        let parent30 : Oas30Document = this.doc30;
        let tag30 : Tag = parent30.addTag(node.name, node.description);
        this.mapNode(node, tag30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        let scheme : Oas20SecurityScheme = <Oas20SecurityScheme>node;
        let parent30 : Oas30Components = this.getOrCreateComponents();
        let scheme30 : Oas30SecurityScheme = parent30.createSecurityScheme(scheme.getName());
        parent30.addSecurityScheme(scheme.getName(), scheme30);
        scheme30.type = scheme.type;
        scheme30.description = scheme.description;
        scheme30.name = scheme.name;
        scheme30.in = scheme.in;
        if(NodeCompat.equals(scheme.type, "oauth2")) {
            if(NodeCompat.equals(scheme.flow, "implicit")) {
                scheme30.flows = scheme30.createOAuthFlows();
                scheme30.flows.implicit = scheme30.flows.createImplicitOAuthFlow();
                scheme30.flows.implicit.authorizationUrl = scheme.authorizationUrl;
                if(!NodeCompat.isNullOrUndefined(scheme.scopes)) {
                    scheme.scopes.getScopeNames().forEach(((scheme,scheme30) => {
                        return (scopeName) => {
                            scheme30.flows.implicit.addScope(scopeName, scheme.scopes.getScopeDescription(scopeName));
                        }
                    })(scheme,scheme30));
                }
            }
            if(NodeCompat.equals(scheme.flow, "accessCode")) {
                scheme30.flows = scheme30.createOAuthFlows();
                scheme30.flows.authorizationCode = scheme30.flows.createAuthorizationCodeOAuthFlow();
                scheme30.flows.authorizationCode.authorizationUrl = scheme.authorizationUrl;
                scheme30.flows.authorizationCode.tokenUrl = scheme.tokenUrl;
                if(!NodeCompat.isNullOrUndefined(scheme.scopes)) {
                    scheme.scopes.getScopeNames().forEach(((scheme,scheme30) => {
                        return (scopeName) => {
                            scheme30.flows.authorizationCode.addScope(scopeName, scheme.scopes.getScopeDescription(scopeName));
                        }
                    })(scheme,scheme30));
                }
            }
            if(NodeCompat.equals(scheme.flow, "password")) {
                scheme30.flows = scheme30.createOAuthFlows();
                scheme30.flows.password = scheme30.flows.createPasswordOAuthFlow();
                scheme30.flows.password.tokenUrl = scheme.tokenUrl;
                if(!NodeCompat.isNullOrUndefined(scheme.scopes)) {
                    scheme.scopes.getScopeNames().forEach(((scheme,scheme30) => {
                        return (scopeName) => {
                            scheme30.flows.password.addScope(scopeName, scheme.scopes.getScopeDescription(scopeName));
                        }
                    })(scheme,scheme30));
                }
            }
            if(NodeCompat.equals(scheme.flow, "application")) {
                scheme30.flows = scheme30.createOAuthFlows();
                scheme30.flows.clientCredentials = scheme30.flows.createClientCredentialsOAuthFlow();
                scheme30.flows.clientCredentials.tokenUrl = scheme.tokenUrl;
                if(!NodeCompat.isNullOrUndefined(scheme.scopes)) {
                    scheme.scopes.getScopeNames().forEach(((scheme,scheme30) => {
                        return (scopeName) => {
                            scheme30.flows.clientCredentials.addScope(scopeName, scheme.scopes.getScopeDescription(scopeName));
                        }
                    })(scheme,scheme30));
                }
            }
        }
        this.mapNode(scheme, scheme30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        let parent30 : Oas30Schema = <Oas30Schema>this.lookup(node.parent());
        let xml30 : Oas30XML = <Oas30XML>parent30.createXML();
        parent30.xml = xml30;
        xml30.name = node.name;
        xml30.namespace = node.namespace;
        xml30.prefix = node.prefix;
        xml30.attribute = node.attribute;
        xml30.wrapped = node.wrapped;
        this.mapNode(node, xml30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        let sd20 : Oas20SchemaDefinition = <Oas20SchemaDefinition><any>node;
        let parent30 : Oas30Components = this.getOrCreateComponents();
        let schemaDef30 : Oas30SchemaDefinition = parent30.createSchemaDefinition(sd20.getName());
        parent30.addSchemaDefinition(sd20.getName(), schemaDef30);
        this.toSchema(sd20, schemaDef30, true);
        this.mapNode(sd20, schemaDef30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.core.models.common.IPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IPropertySchema) {
        let ps20 : Oas20Schema.Oas20PropertySchema = <Oas20Schema.Oas20PropertySchema><any>node;
        let parent30 : Oas30Schema = <Oas30Schema>this.lookup(ps20.parent());
        let property30 : Oas30Schema.Oas30PropertySchema = <Oas30Schema.Oas30PropertySchema>parent30.createPropertySchema(ps20.getPropertyName());
        parent30.addProperty(ps20.getPropertyName(), property30);
        this.toSchema(ps20, property30, true);
        this.mapNode(ps20, property30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        let parent30 : Oas30Schema = <Oas30Schema>this.lookup(node.parent());
        let additionalProps30 : Oas30Schema.Oas30AdditionalPropertiesSchema = <Oas30Schema.Oas30AdditionalPropertiesSchema>parent30.createAdditionalPropertiesSchema();
        parent30.additionalProperties = additionalProps30;
        this.toSchema(node, additionalProps30, true);
        this.mapNode(node, additionalProps30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        let parent30 : Oas30Schema = <Oas30Schema>this.lookup(node.parent());
        let allOf30 : Oas30Schema.Oas30AllOfSchema = <Oas30Schema.Oas30AllOfSchema>parent30.createAllOfSchema();
        if(NodeCompat.isNullOrUndefined(parent30.allOf)) {
            parent30.allOf = <any>([]);
        }
        /* add */(parent30.allOf.push(allOf30)>0);
        this.toSchema(node, allOf30, true);
        this.mapNode(node, allOf30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        let parent30 : Oas30Schema = <Oas30Schema>this.lookup(node.parent());
        let items30 : Oas30Schema.Oas30ItemsSchema = <Oas30Schema.Oas30ItemsSchema>parent30.createItemsSchema();
        if(!NodeCompat.isNullOrUndefined(parent30.items) && NodeCompat.isNode(parent30.items)) {
            let items : Array<Oas30Schema.Oas30ItemsSchema> = <any>([]);
            /* add */(items.push(items30)>0);
            parent30.items = items;
        } else {
            parent30.items = items30;
        }
        this.toSchema(node, items30, true);
        this.mapNode(node, items30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        let parent30 : ExtensibleNode = <ExtensibleNode>this.lookup(node.parent());
        let ext30 : Extension = parent30.createExtension();
        ext30.name = node.name;
        ext30.value = node.value;
        parent30.addExtension(node.name, ext30);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
    }

    /*private*/ mapNode(from : Node, to : Node) {
        let nodePath : NodePath = Library.createNodePath(from);
        let mapIndex : string = nodePath.toString();
        /* put */(this._nodeMap[mapIndex] = to);
    }

    /*private*/ lookup(node : Node) : Node {
        let nodePath : NodePath = Library.createNodePath(node);
        let mapIndex : string = nodePath.toString();
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this._nodeMap, mapIndex);
    }

    /*private*/ getOrCreateComponents() : Oas30Components {
        if(NodeCompat.isNullOrUndefined(this.doc30.components)) {
            this.doc30.components = this.doc30.createComponents();
        }
        return this.doc30.components;
    }

    /*private*/ toSchema(from : Node, schema30 : Oas30Schema, isSchema : boolean) : Oas30Schema {
        let type : string = <string>NodeCompat.getProperty(from, Constants.PROP_TYPE);
        let format : string = <string>NodeCompat.getProperty(from, Constants.PROP_FORMAT);
        let items : any = NodeCompat.getProperty(from, Constants.PROP_ITEMS);
        let default_ : any = NodeCompat.getProperty(from, Constants.PROP_DEFAULT);
        let maximum : number = <number>NodeCompat.getProperty(from, Constants.PROP_MAXIMUM);
        let exclusiveMaximum : boolean = <boolean>NodeCompat.getProperty(from, Constants.PROP_EXCLUSIVE_MAXIMUM);
        let minimum : number = <number>NodeCompat.getProperty(from, Constants.PROP_MINIMUM);
        let exclusiveMinimum : boolean = <boolean>NodeCompat.getProperty(from, Constants.PROP_EXCLUSIVE_MINIMUM);
        let maxLength : number = <number>NodeCompat.getProperty(from, Constants.PROP_MAX_LENGTH);
        let minLength : number = <number>NodeCompat.getProperty(from, Constants.PROP_MIN_LENGTH);
        let pattern : string = <string>NodeCompat.getProperty(from, Constants.PROP_PATTERN);
        let maxItems : number = <number>NodeCompat.getProperty(from, Constants.PROP_MAX_ITEMS);
        let minItems : number = <number>NodeCompat.getProperty(from, Constants.PROP_MIN_ITEMS);
        let uniqueItems : boolean = <boolean>NodeCompat.getProperty(from, Constants.PROP_UNIQUE_ITEMS);
        let enum_ : Array<string> = <Array<string>><any>NodeCompat.getProperty(from, Constants.PROP_ENUM);
        let multipleOf : number = <number>NodeCompat.getProperty(from, Constants.PROP_MULTIPLE_OF);
        schema30.type = type;
        schema30.format = format;
        if(NodeCompat.equals(type, "file")) {
            schema30.type = "string";
            schema30.format = "binary";
        }
        if(NodeCompat.isNode(items)) {
            (<Node>items).setAttribute("_transformation_items-parent", schema30);
        } else if(NodeCompat.isList(items)) {
        }
        schema30.default_ = default_;
        schema30.maximum = maximum;
        schema30.exclusiveMaximum = exclusiveMaximum;
        schema30.minimum = minimum;
        schema30.exclusiveMinimum = exclusiveMinimum;
        schema30.maxLength = maxLength;
        schema30.minLength = minLength;
        schema30.pattern = pattern;
        schema30.maxItems = maxItems;
        schema30.minItems = minItems;
        schema30.uniqueItems = uniqueItems;
        schema30.enum_ = enum_;
        schema30.multipleOf = multipleOf;
        if(isSchema) {
            let schema20 : Oas20Schema = <Oas20Schema>from;
            schema30.$ref = this.updateRef(schema20.$ref);
            if(schema20.hasAdditionalPropertiesBoolean()) {
                schema30.additionalProperties = schema20.additionalProperties;
            }
            schema30.readOnly = schema20.readOnly;
            schema30.example = schema20.example;
            schema30.title = schema20.title;
            schema30.description = schema20.description;
            schema30.maxProperties = schema20.maxProperties;
            schema30.minProperties = schema20.minProperties;
            schema30.required = schema20.required;
            if(!NodeCompat.isNullOrUndefined(schema20.discriminator)) {
                schema30.discriminator = schema30.createDiscriminator();
                schema30.discriminator.propertyName = schema20.discriminator;
            }
        }
        return schema30;
    }

    /*private*/ findItemsParent(node : Oas20Items) : Oas30Schema {
        let itemsParent : Oas30Schema = <Oas30Schema>node.getAttribute("_transformation_items-parent");
        if(NodeCompat.isNullOrUndefined(itemsParent)) {
            itemsParent = <Oas30Schema>this.lookup(node.parent());
        }
        return itemsParent;
    }

    /*private*/ findParentOperation(node : Parameter) : Oas20Operation {
        let finder : OperationFinder = new OperationFinder();
        Library.visitTree(node, finder, TraverserDirection.up);
        return <Oas20Operation>finder.found;
    }

    /*private*/ findProduces(node : Node) : Array<string> {
        let finder : ConsumesProducesFinder = new ConsumesProducesFinder();
        Library.visitTree(node, finder, TraverserDirection.up);
        let produces : Array<string> = finder.produces;
        if(NodeCompat.isNullOrUndefined(produces) || /* size */(<number>produces.length) === 0) {
            produces = <any>([]);
            /* add */(produces.push("*/*")>0);
        }
        return produces;
    }

    /*private*/ findConsumes(node : Node) : Array<string> {
        let finder : ConsumesProducesFinder = new ConsumesProducesFinder();
        Library.visitTree(node, finder, TraverserDirection.up);
        let consumes : Array<string> = finder.consumes;
        if(NodeCompat.isNullOrUndefined(consumes) || /* size */(<number>consumes.length) === 0) {
            consumes = <any>([]);
            /* add */(consumes.push("*/*")>0);
        }
        return consumes;
    }

    /*private*/ collectionFormatToStyleAndExplode(node : Oas20Parameter, param30 : Oas30Parameter) {
        if(NodeCompat.equals(node.type, "array") && NodeCompat.equals(node.collectionFormat, "multi") && (NodeCompat.equals(node.in, "query") || NodeCompat.equals(node.in, "cookie"))) {
            param30.style = "form";
            param30.explode = true;
            return;
        }
        if(NodeCompat.equals(node.type, "array") && NodeCompat.equals(node.collectionFormat, "csv") && (NodeCompat.equals(node.in, "query") || NodeCompat.equals(node.in, "cookie"))) {
            param30.style = "form";
            param30.explode = false;
            return;
        }
        if(NodeCompat.equals(node.type, "array") && NodeCompat.equals(node.collectionFormat, "csv") && (NodeCompat.equals(node.in, "path") || NodeCompat.equals(node.in, "header"))) {
            param30.style = "simple";
            return;
        }
        if(NodeCompat.equals(node.type, "array") && NodeCompat.equals(node.collectionFormat, "ssv") && NodeCompat.equals(node.in, "query")) {
            param30.style = "spaceDelimited";
            return;
        }
        if(NodeCompat.equals(node.type, "array") && NodeCompat.equals(node.collectionFormat, "pipes") && NodeCompat.equals(node.in, "query")) {
            param30.style = "pipeDelimited";
            return;
        }
    }

    /*private*/ isFormDataMimeType(mimetype : string) : boolean {
        return !NodeCompat.isNullOrUndefined(mimetype) && (NodeCompat.equals(mimetype, "multipart/form-data") || NodeCompat.equals(mimetype, "application/x-www-form-urlencoded"));
    }

    /*private*/ hasFormDataMimeType(mimetypes : Array<string>) : boolean {
        if(!NodeCompat.isNullOrUndefined(mimetypes)) {
            for(let index242=0; index242 < mimetypes.length; index242++) {
                let mt = mimetypes[index242];
                {
                    if(this.isFormDataMimeType(mt)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    /*private*/ isRef(node : IReferenceNode) : boolean {
        let $ref : string = <string>NodeCompat.getProperty(node, Constants.PROP_$REF);
        return !NodeCompat.isNullOrUndefined($ref) && $ref.length > 0;
    }

    /*private*/ updateRef($ref : string) : string {
        if(NodeCompat.isNullOrUndefined($ref) || $ref.length === 0) {
            return $ref;
        }
        let split : string[] = $ref.split("/");
        if(NodeCompat.equals(split[0], "#")) {
            if(NodeCompat.equals(split[1], "definitions")) {
                return /* replace */$ref.split("#/definitions/").join("#/components/schemas/");
            } else if(NodeCompat.equals(split[1], "parameters")) {
                return /* replace */$ref.split("#/parameters/").join("#/components/parameters/");
            } else if(NodeCompat.equals(split[1], "responses")) {
                return /* replace */$ref.split("#/responses/").join("#/components/responses/");
            }
        }
        return $ref;
    }

    /**
     * Called when visiting is complete.  Any additional processing of the result can
     * be done here.
     * @private
     */
    /*private*/ postProcess() {
        this._postProcessResponses.forEach((response) => {
            let largest : number = 0;
            let srcMt : Oas30MediaType = null;
            {
                let array244 = response.getMediaTypes();
                for(let index243=0; index243 < array244.length; index243++) {
                    let mt = array244[index243];
                    {
                        let size : number = JsonCompat.stringify(Library.writeNode(mt.schema)).length;
                        if(size > largest) {
                            largest = size;
                            srcMt = mt;
                        }
                    }
                }
            }
            {
                let array246 = response.getMediaTypes();
                for(let index245=0; index245 < array246.length; index245++) {
                    let mt = array246[index245];
                    {
                        if(srcMt !== mt) {
                            let src : any = Library.writeNode(srcMt.schema);
                            Library.readNode(src, mt.schema);
                        }
                    }
                }
            }
        });
    }

    constructor() {
        if(this.doc30===undefined) this.doc30 = null;
    }
}
Oas20to30TransformationVisitor["__class"] = "io.apicurio.datamodels.openapi.visitors.transform.Oas20to30TransformationVisitor";
Oas20to30TransformationVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




